import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Staff } from '../entity/Staff';
import { environment } from 'src/environments/environment';
 

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  private baseUrl = environment.restApi;
  private staffsUrl = `${this.baseUrl}utilisateurs`;
  private staffsUrlERP = `${environment.restApiERP}utilisateurs`;
  private staffsUrlAncienERP = `${environment.restApiAncienERP}utilisateurs`;

    private currentUserSubject: BehaviorSubject<Staff>;
    public currentUser: Observable<Staff>;

    constructor(private http: HttpClient) {
        this.currentUserSubject = new BehaviorSubject<Staff>(JSON.parse(localStorage.getItem('currentUser')));
        this.currentUser = this.currentUserSubject.asObservable();
    }

    public get currentUserValue(): Staff {
        return this.currentUserSubject.value;
    }
    public get currentUserObserve(): Observable<Staff> {
        return this.currentUser;
    }
    login(username, password) {
 console.log(`${this.staffsUrl}/loginUs`);
 
        let staff:Staff=new Staff ();
        staff.login=username;
        staff.password=password;
        return this.http.post<Staff>(`${this.staffsUrl}/loginUs`,staff)
            .pipe(map(user => {
                console.log(user);
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('idProjet',"1");
                localStorage.setItem('currentUser', JSON.stringify(user));
                localStorage.setItem('currentRole', user.roleUser);
                localStorage.setItem('idUser', user.userId.toString());
              
              
                localStorage.setItem("username",username)
                ,localStorage.setItem("password",password)

console.log("tokentokentokentokentoken",user.token);

                localStorage.setItem("token",user.token)
                this.currentUserSubject.next(user);
                return user;
            }));
         
    }
    loginERP(username, password) {
        let staff:Staff=new Staff ();
        staff.login=username;
        staff.password=password;
        console.log(`${this.staffsUrlERP}/loginUsPr`);
        
        return this.http.post<Staff>(`${this.staffsUrlERP}/loginUsPr`,staff) ;
    }
    loginAncienERP(username, password) {
        let staff:Staff=new Staff ();
        staff.login=username;
        staff.password=password;
        return this.http.post<Staff>(`${this.staffsUrlAncienERP}/loginUsPr`,staff) ;
    }

    logout() {
        // remove user from local storage and set current user to null
       
     
        localStorage.removeItem('currentUser');
        localStorage.removeItem('currentRole');
        localStorage.removeItem('idUser');
        localStorage.removeItem('token')
        localStorage.removeItem('tokenERP')
        localStorage.removeItem('tokenAncienERP')

        

        this.currentUserSubject.next(null);
    }
}